import { getFirebaseAuthLocalStorageKey } from '@/services/firebase-service/firebase-client';

import z from 'zod';

const JWTSchema = z.object({
  aud: z.string(),
  email: z.string().email(),
  email_verified: z.boolean(),
  auth_time: z.number(),
  exp: z.number(),
  iat: z.number(),
  iss: z.string(),
  sub: z.string(),
});

type ParsedToken = z.infer<typeof JWTSchema>;

const authObjectSchema = z.object({
  stsTokenManager: z.object({
    accessToken: z.string(),
  }),
});

const CUSTOM_EXPIRY_TIME = 30 * 60 * 1000;

export const getCustomExpiryTime = () => CUSTOM_EXPIRY_TIME;

export const getFirebaseTokenFromLocalStorage = (): string | null => {
  // Get Firebase token from local storage, so we don't trigger a refresh
  const key = getFirebaseAuthLocalStorageKey();
  if (!key) return null;
  const authObjectRaw = localStorage.getItem(key);

  if (!authObjectRaw) return null;

  const authObj = authObjectSchema.parse(JSON.parse(authObjectRaw));
  const token = authObj.stsTokenManager.accessToken;
  return token;
};

export const decodeFirebaseToken = (token: string): ParsedToken => {
  if (!token) {
    throw new Error('Cannot decode empty token');
  }

  const decoded = JSON.parse(atob(token.split('.')[1]));
  return JWTSchema.parse(decoded);
};

export const calculateTimeLeft = (iat: number) => {
  const now = Date.now();
  const customExpiryTime =
    new Date(iat * 1000).getTime() + getCustomExpiryTime();
  const timeLeft = Math.min(
    Math.max(customExpiryTime - now, 0),
    getCustomExpiryTime(),
  );
  return timeLeft;
};
